export const promiseUtil = {
  isPromiseFulfilled: <T>(settled: PromiseSettledResult<T>): settled is PromiseFulfilledResult<T> =>
    settled.status === 'fulfilled',
}
